var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nothing-warp"},[_c('img',{attrs:{"src":_vm.static_img_url + 'pic/none-data.png?v=' + _vm.$store.state.imgVersion}}),_c('div',{staticClass:"nothing-text"},[_vm._v(_vm._s(_vm._f("dealLanguage")(_vm.title,_vm.enTitle)))]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }